import { useMemo } from "react";
import { useParams } from "react-router-dom";

import { alignItems, strCode } from "../../consts";
import { t } from "../../services";
import { notificationUtils } from "../../utils";
import { withSection } from "../../hoc";
import { useCreateNotification } from "../../apiHooks";

import {
  Breadcrumbs,
  FlexContainers,
  Heading5,
  PageContainer,
  WrapperContainer
} from "../../components";
import { NewNotificationForm } from "../../containers";

const CreateNotificationPage = () => {
  const { isSystemNotification: _isSystemNotification } = useParams();
  const isSystemNotification = _isSystemNotification == "true";

  const { mutationCallback: createNotification } = useCreateNotification();

  const availableSystemNotificationOptions = useMemo(() => {
    return notificationUtils.getAvailableSystemNotificationOptions();
  }, []);

  return (
    <PageContainer alignItems={alignItems.start}>
      <WrapperContainer
        Container={FlexContainers.FlexColumnStart}
        alignItems={alignItems.start}
        width="100%"
        height="100%">
        <WrapperContainer>
          <Breadcrumbs />
          <Heading5>{t(strCode.CREATE_NOTIFICATION_TITLE)}</Heading5>
        </WrapperContainer>

        <NewNotificationForm
          onSaveNotification={createNotification}
          isSystemNotification={isSystemNotification}
          availableSystemNotificationOptions={availableSystemNotificationOptions}
        />
      </WrapperContainer>
    </PageContainer>
  );
};

export default withSection(CreateNotificationPage);
